<div class="step-2-wrapper">
    <div class="banner-resum border rounded p-3"  [style.background-color]="community?.color1 ? _themeService.getColorWithOpacity(community.color1, 0.2) : 'white'">
        <h2 class="fw-600">{{ (preReservationLabels ? 'PREAPPOINTMENTFINISH.summary' : 'PRIORAPPOINTMENTFINISH.summary') | translate }}</h2>
        <div class="row">
            <div class="col-12 col-md-6 mb-2"><span class="fw-600 me-1">{{ (preReservationLabels ? 'PREAPPOINTMENTFINISH.center' : 'PRIORAPPOINTMENTFINISH.center') | translate }}: </span> <span> {{reservation.centerName}}</span> </div>
            <div class="col-12 col-md-6 mb-2"><span class="fw-600 me-1">{{ (preReservationLabels ? 'PREAPPOINTMENTFINISH.type' : 'PRIORAPPOINTMENTFINISH.type') | translate }}: </span> <span> {{reservation.type === 0 ? ((preReservationLabels ? 'PREAPPOINTMENTFINISH.inPerson' : 'PRIORAPPOINTMENTFINISH.inPerson') | translate) : ((preReservationLabels ? 'PREAPPOINTMENTFINISH.online' : 'PRIORAPPOINTMENTFINISH.online') | translate)}}</span> </div>
            <div class="col-12 col-md-6 mb-2"><span class="fw-600 me-1">{{ (preReservationLabels ? 'PREAPPOINTMENTFINISH.service' : 'PRIORAPPOINTMENTFINISH.service') | translate }}:</span>  <span> {{reservation.serviceName}}</span> </div>
            <div class="col-12 col-md-6 mb-2"><span class="fw-600 me-1">{{ (preReservationLabels ? 'PREAPPOINTMENTFINISH.date' : 'PRIORAPPOINTMENTFINISH.date') | translate }}: </span> <span> {{reservation.startTime | date: "dd/MM/yy"}}</span> </div>
            <div class="col-12 col-md-6 mb-2"><span class="fw-600 me-1">{{ (preReservationLabels ? 'PREAPPOINTMENTFINISH.hour' : 'PRIORAPPOINTMENTFINISH.hour') | translate }}: </span> <span> {{reservation.startTime | date: "hh:mm"}}</span> </div>
        </div>
    </div>
    <form [formGroup]="form" class="mt-5">
        <div class="d-flex flex-wrap align-items-center justify-content-between gap-3 mb-3">
            <h2 class="fw-600 mb-0">{{ (preReservationLabels ? 'PREAPPOINTMENT.stepPersonalData' : 'PRIORAPPOINTMENT.stepPersonalData') | translate }}</h2>
            <reservation-countdown *ngIf="holdLeftSeconds !== null" [reservedSeconds]="holdLeftSeconds" ui="block"></reservation-countdown>
        </div>

        <div class="row">
            <div class="col-12 col-md-6 mb-3">
                <label class="mb-2 font-w-600"
                       [ngClass]="form.controls['name'].invalid && form.controls['name'].touched ? 'text-danger' : ''">
                    {{ (preReservationLabels ? 'PREAPPOINTMENTFINISH.name' : 'PRIORAPPOINTMENTFINISH.name') | translate }} *
                </label>
                <br>
                <input type="text" class="w-100" pInputText [(ngModel)]="reservation.name" id="name" formControlName="name" />
                <p class="text-danger" *ngIf="form.controls['name'].invalid && form.controls['name'].touched">
                    {{ (preReservationLabels ? 'PREAPPOINTMENT.fieldRequired' : 'STEP2.fieldRequired') | translate }}
                </p>
            </div>

            <div class="col-12 col-md-6 mb-3">
                <label class="mb-2 font-w-600"
                       [ngClass]="form.controls['surname'].invalid && form.controls['surname'].touched ? 'text-danger' : ''">
                    {{ (preReservationLabels ? 'PREAPPOINTMENTFINISH.surname' : 'PRIORAPPOINTMENTFINISH.surname') | translate }} *
                </label>
                <br>
                <input type="text" class="w-100" pInputText [(ngModel)]="reservation.surname" id="surname" formControlName="surname" />
                <p class="text-danger" *ngIf="form.controls['surname'].invalid && form.controls['surname'].touched">
                    {{ (preReservationLabels ? 'PREAPPOINTMENT.fieldRequired' : 'STEP2.fieldRequired') | translate }}
                </p>
            </div>

            <div class="col-12 col-md-6 mb-3">
                <label class="mb-2 font-w-600"
                       [ngClass]="form.controls['phone'].invalid && form.controls['phone'].touched ? 'text-danger' : ''">
                    {{ (preReservationLabels ? 'PREAPPOINTMENTFINISH.phone' : 'PRIORAPPOINTMENTFINISH.phone') | translate }} *
                </label>
                <br>
                <input type="text" class="w-100" pInputText [(ngModel)]="reservation.phone" id="phone" formControlName="phone" />
                <p class="text-danger" *ngIf="form.controls['phone'].invalid && form.controls['phone'].touched">
                    {{ (preReservationLabels ? 'PREAPPOINTMENT.fieldRequired' : 'STEP2.fieldRequired') | translate }}
                </p>
            </div>

            <div class="col-12 col-md-6 mb-3">
                <label class="mb-2 font-w-600"
                       [ngClass]="form.controls['email'].invalid && form.controls['email'].touched ? 'text-danger' : ''">
                    {{ (preReservationLabels ? 'PREAPPOINTMENTFINISH.email' : 'PRIORAPPOINTMENTFINISH.email') | translate }} *
                </label>
                <br>
                <input type="email" class="w-100" pInputText [(ngModel)]="reservation.mail" id="email" formControlName="email" />
                <p class="text-danger" *ngIf="form.controls['email'].invalid && form.controls['email'].touched">
                    {{ (preReservationLabels ? 'PREAPPOINTMENT.fieldRequired' : 'STEP2.fieldRequired') | translate }}
                </p>
            </div>

            <div class="col-12 col-md-6 mb-3">
                <label class="mb-2 font-w-600"
                       [ngClass]="form.controls['documentType'].invalid && form.controls['documentType'].touched ? 'text-danger' : ''">{{ (preReservationLabels ? 'PREAPPOINTMENT.documentType' : 'STEP2.documentType') | translate }} *</label>
                <br>
                <p-dropdown
                        [options]="documentTypes"
                        [(ngModel)]="reservation.documentType"
                        id="documentType"
                        label="name"
                        value="value"
                        formControlName="documentType">
                </p-dropdown>
                <p class="text-danger" *ngIf="form.controls['documentType'].invalid && form.controls['documentType'].touched">
                    {{ (preReservationLabels ? 'PREAPPOINTMENT.fieldRequired' : 'STEP2.fieldRequired') | translate }}
                </p>
            </div>

            <div class="col-12 col-md-6 mb-3">
                <label class="mb-2 font-w-600"
                       [ngClass]="form.controls['documentNumber'].invalid && form.controls['documentNumber'].touched ? 'text-danger' : ''">
                    {{ (preReservationLabels ? 'PREAPPOINTMENT.documentNumber' : 'STEP2.documentNumber') | translate }} *
                </label>
                <br>
                <input type="text" class="w-100" pInputText [(ngModel)]="reservation.numberDocumentation" id="documentNumber" formControlName="documentNumber" />
                <p class="text-danger" *ngIf="form.controls['documentNumber'].hasError('required') && form.controls['documentNumber'].touched">
                    {{ (preReservationLabels ? 'PREAPPOINTMENT.fieldRequired' : 'STEP2.fieldRequired') | translate }}
                </p>
                <p class="text-danger" *ngIf="form.controls['documentNumber'].hasError('pattern') && form.controls['documentNumber'].touched">
                    {{(preReservationLabels ? 'PREAPPOINTMENT.documentInvalid' : 'PRIORAPPOINTMENT.documentInvalid') | translate}}
                </p>
            </div>

            <div class="col-12 col-md-6 mb-3">
                <label class="mb-2 font-w-600">{{ (preReservationLabels ? 'PREAPPOINTMENT.observations' : 'STEP2.observations') | translate }}</label>
                <br>
                <textarea class="w-100" pInputTextarea [(ngModel)]="reservation.observations" id="observations" formControlName="observations">
                </textarea>
            </div>
        </div>
        <div class="row" *ngIf="additionalDataLoading">
            <div class="col-12 mb-4">
                <h3 class="fw-600 mb-3">{{ (preReservationLabels ? 'PREAPPOINTMENT.additionalData' : 'PRIORAPPOINTMENT.additionalData') | translate }}</h3>
                <ng-container *ngFor="let _ of additionalDataSkeletonRows">
                    <div class="mb-3">
                        <p-skeleton width="40%" height="0.75rem" styleClass="mb-2 rounded-2"></p-skeleton>
                        <p-skeleton width="100%" height="2.75rem" styleClass="rounded-2"></p-skeleton>
                    </div>
                </ng-container>
            </div>
        </div>
        <div class="row" *ngIf="!additionalDataLoading && mergedCustomFields?.length > 0">
            <div class="col-12 mb-4">
                <h3 class="fw-600 mb-3">{{ (preReservationLabels ? 'PREAPPOINTMENT.additionalData' : 'PRIORAPPOINTMENT.additionalData') | translate }}</h3>
                <app-custom-fields-form
                    [customFields]="mergedCustomFields"
                    [formGroup]="form"
                    [formBuilder]="fb"
                    [submitAttempted]="submitAttempted"
                    (priceChanged)="onCustomFieldsPriceChanged()">
                </app-custom-fields-form>
            </div>
        </div>
        <div class="row">
            <div class="col-12 mb-4">
                <div class="form-check">
                    <input
                            type="checkbox"
                            class="form-check-input"
                            style="width: 1em;"
                            id="acceptTractament"
                            formControlName="acceptTractament"
                    />
                    <label
                            for="acceptTractament"
                            class="form-check-label"
                            [innerHTML]="reservation.rgpd"
                    >
                    </label>
                </div>
                <p class="text-danger" *ngIf="form.controls['acceptTractament'].invalid && form.controls['acceptTractament'].touched">
                    {{ (preReservationLabels ? 'PREAPPOINTMENT.acceptConsent' : 'STEP2.acceptConsent') | translate }}
                </p>
            </div>
        </div>
    </form>
</div>
